import React from 'react';
import './StarGrade.css';

const STARS = [1, 2, 3, 4, 5];

// The 1-5 grade a coach gives an athlete (saved athletes and list members), shown as
// stars to match the Android app's StarPicker. With onChange it is a picker — clicking
// the current count clears the grade; without it, a read-only display.
export default function StarGrade({ value, onChange, label = 'Grade' }) {
  if (!onChange) {
    return (
      <span className="star-grade star-grade--readonly" role="img" aria-label={`${value || 0} of 5 stars`}>
        {STARS.map((n) => (
          <span key={n} className={n <= value ? 'star-grade__star is-on' : 'star-grade__star'} aria-hidden="true">★</span>
        ))}
      </span>
    );
  }
  return (
    <span className="star-grade" role="group" aria-label={label}>
      {STARS.map((n) => (
        <button key={n} type="button" className={n <= value ? 'star-grade__star is-on' : 'star-grade__star'}
          aria-label={n === 1 ? '1 star' : `${n} stars`} aria-pressed={n === value}
          onClick={(e) => { e.stopPropagation(); onChange(n === value ? null : n); }}>★</button>
      ))}
    </span>
  );
}
